module.exports = "/_next/static/images/a368e5ddccffdefea82a48d204bb2df8-NoManagementFee.png.webp";